module.exports = __webpack_public_path__ + "img/basin.eff979d3.jpg";